import app from 'app';
import templateUrl from './mxExampleListModal.html';
import './mxExampleListModal.scss';

import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-plus';

app.component('mxExampleListModal', {
  bindings: {
    $close: '<?',
    title: '<',
    subtitle: '<',
    list: '<',
  },
  controllerAs: 'MxExampleListModal',
  templateUrl,
});

export default 'mxExampleListModal';
